import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Quiz from './pages/Quiz';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import Subscribe from './pages/Subscribe';
import Glossary from './pages/Glossary';
import Resources from './pages/Resources';
import Listen from './pages/Listen';
import About from './pages/About';
import Refuge from './pages/Refuge';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import BackInCourt from './pages/BackInCourt';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ActivateMembership from './pages/ActivateMembership';
import QA from './pages/QA';
import Contact from './pages/Contact';
import LegalAid from './pages/LegalAid';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={styles.loading}>Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <div style={styles.app}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/quiz" element={<PrivateRoute><Quiz /></PrivateRoute>} />
          <Route path="/subscribe" element={<PrivateRoute><Subscribe /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          <Route path="/qa" element={<QA />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/listen" element={<Listen />} />
          <Route path="/about" element={<About />} />
          <Route path="/refuge" element={<Refuge />} />
          <Route path="/back-in-court" element={<PrivateRoute><BackInCourt /></PrivateRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/activate-membership" element={<ActivateMembership />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal-aid" element={<LegalAid />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

const styles = {
  app: { minHeight: '100vh', backgroundColor: '#fdf6f0', fontFamily: 'Georgia, serif' },
  loading: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '18px', color: '#8b5e3c' }
};

export default App;
